import React, {useState, useContext} from 'react';
import {
  Card,
  CardBoldText,
  LinkContainer,
  LinkSpace
} from 'app/src/elements';
import { Text, Pressable } from 'react-native';
import Modal from './Modal';
import EditSellerUser from '../components/Users/SellerUsers/edit';
import { useMutation } from '@apollo/client';
import {
  HIDE_SELLER_USER,
  REINVITE_SELLER_USER
} from '../components/Users/SellerUsers/queries';
import AuthContext from '../contexts/AuthContext';

const SellerUserCard = props => {
  const { hasPolicy } = useContext(AuthContext);
  const { sellerUser, setShowModal, setUpdatedSellerUserDetails } = props;
  const [showEditSellerUserModal, setShowEditSellerUserModal] = useState(false);

  const [hideSellerUser] = useMutation(HIDE_SELLER_USER, {
    onCompleted: (response) => {
      // navigate(`/sellers${sellerId}`);
      // setShowModal(false);
      setUpdatedSellerUserDetails(
        response?.hideSellerUser?.sellerUser, false, true
      )
    }
  });

  const [reinviteSellerUser] = useMutation(REINVITE_SELLER_USER);

  const onHide = () => {
    hideSellerUser({ variables: {id: sellerUser.id} });
  }

  const onReinviteSellerUser = () => {
    let message = sellerUser.invitationAcceptedAt ?
      'This will send an email with password reset instructions' :
      'This will send a new invitiation email';

    message = `${message} to ${sellerUser.email}. Continue?`;

    if (confirm(message)) {
      reinviteSellerUser({ variables: { id: sellerUser.id } });
    }
  }

  return (
    <Card>
      <CardBoldText>
        {`${sellerUser.firstName} ${sellerUser.lastName}`}
        {'Admin' === sellerUser.role && ` - Admin`}
      </CardBoldText>
      <Text>{sellerUser.email}</Text>
      {sellerUser.contact &&
        <Text>
          <b>Contact: </b>
          {`${sellerUser.contact.firstName} - ${sellerUser.email}`}
        </Text>
      }
      {hasPolicy({ type: 'SellerUser', action: 'update' }) && (
        <LinkContainer style={{marginTop: '20px', justifyContent: 'flex-end'}}>
          <Pressable
            onPress={() => setShowEditSellerUserModal(true)}
            style={{alignSelf: 'flex-end'}}
          >
            <Text>
              edit
            </Text>
          </Pressable>
          <LinkSpace />
          <Pressable
            onPress={onReinviteSellerUser}
            style={{alignSelf: 'flex-end'}}
          >
            <Text>
              {sellerUser.invitationAcceptedAt ?
                'send password reset' : 'resend invite'
              }
            </Text>
          </Pressable>
          <LinkSpace />
          <Pressable
            onPress={() => window.confirm('Hide SellerUser?', onHide())}
            style={{alignSelf: 'flex-end'}}
          >
            <Text>
              hide
            </Text>
          </Pressable>
        </LinkContainer>
      )}
      {showEditSellerUserModal &&
        <Modal
          sellerUser={sellerUser}
          showModal={showEditSellerUserModal}
          setShowModal={setShowEditSellerUserModal}
          modalType={'Edit SellerUser'}
          objectName={`${sellerUser.firstName ? sellerUser.firstName : ''}
            ${sellerUser.lastName ? ' ' + sellerUser.lastName : ''}
          `}
        >
          <EditSellerUser
            setShowModal={setShowEditSellerUserModal}
            sellerUser={sellerUser}
            setUpdatedSellerUserDetails={setUpdatedSellerUserDetails}
          />
        </Modal>
      }
    </Card>
  )
}

export default SellerUserCard;
